import { UITable } from '../../components/table/ui-table';
import type { ComponentPlugin } from '../../components/ui-element.type';

/**
 * @class
 * @memberof SharedComponents
 * @classdesc Class for ui-table sticky headers plugin.
 * @alias UITableSticky
 * @implements {ComponentPlugin}
 * @param {HTMLTableElement} target
 */
export class UITableSticky implements ComponentPlugin {
    private readonly target: UITable;

    constructor(target: UITable) {
        this.target = target;
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.target.table.classList.add('-sticky');
    }
}

UITable.registerPlugin('sticky', UITableSticky);
